module.exports = __webpack_public_path__ + "img/bruxelles-mexico-oro-2018.84db33e0.png";